export const servicesPageIntro = {
  title: 'Services',
  subtitle:
    'We take great pride in delivering top-notch professional services, ensuring you leave our salon feeling absolutely amazing!',
};

export const servicesList = [
  {
    id: 'threading',
    title: 'Threading',
    summary:
      'Achieve perfectly shaped brows and a flawless finish with our expert threading services. Gentle and precise, threading is a natural technique that removes unwanted hair while defining your features.',
    price: '$15',
    modal: {
      about: 'Threading)',
      process: ['Consultation', 'Cleaning', 'Threading', 'Final touches'],
      aftercare: ['Avoid touching', 'Apply cooling gel'],
      recommendations: 'Come back in 3 weeks',
    },
  },
  {
    id: 'waxing',
    title: 'Waxing (Full Body Waxing)',
    summary:
      'Feel smooth and confident with our full-body waxing services. From legs to arms and everything in between, we use high-quality wax for a gentle, effective, and long-lasting hair removal experience tailored to your needs.',
    price: '$30',
    modal: {
      about: 'Semi-permanent tinting for fuller looking brows',
      process: ['Color selection', 'Application', 'Setting', 'Clean up'],
      aftercare: ['Keep dry for 24 hours', 'Avoid harsh products'],
      recommendations: 'Refresh every 4-6 weeks',
    },
  },
  {
    id: 'eyelashes',
    title: 'Eyelashes',
    summary:
      'Enhance your natural beauty with our eyelash services. Whether you want a subtle lift or dramatic volume, we will help you achieve the look you desire with options that fit your style.',
    price: '$75',
    modal: {
      about: 'Rejuvenating facial designed to cleanse, exfoliate, and hydrate your skin.',
      process: ['Skin Analysis', 'Cleansing', 'Exfoliation', 'Mask Application', 'Moisturizing'],
      aftercare: ['Use sunscreen', 'Avoid heavy makeup for 24 hours'],
      recommendations: 'Refresh every 4-6 weeks',
    },
  },
  {
    id: 'eyelash-extensions',
    title: 'Eyelash Extensions',
    summary:
      'Transform your lashes with our luxurious eyelash extensions. Customized to suit your preferences, these semi-permanent extensions add length, volume, and glamour for a stunning, effortless look.',
    price: '$25',
    modal: {
      about: 'Classic manicure to keep your nails and cuticles neat and polished.',
      process: ['Nail Shaping', 'Cuticle Care', 'Buffing', 'Polish Application'],
      aftercare: ['Moisturize hands and cuticles', 'Avoid harsh chemicals'],
      recommendations: 'Refresh every 2-3 weeks',
    },
  },
  {
    id: 'cluster-lashes',
    title: 'Cluster Lashes',
    summary:
      'Get instant drama and volume with our cluster lash application. Perfect for special occasions, these lashes add a bold and beautiful effect in no time.',
    price: '$50',
    modal: {
      about: 'Professional haircut customized to enhance your features and fit your preferences.',
      process: ['Consultation', 'Wash', 'Cut and Style', 'Finishing Touches'],
      aftercare: ['Use quality hair products', 'Schedule regular trims'],
      recommendations: 'Refresh every 4-8 weeks',
    },
  },
  {
    id: 'strip-lashes',
    title: 'Strip Lashes',
    summary:
      'Looking for a quick lash enhancement? Our strip lashes offer a temporary yet stunning solution, giving you a full and defined lash line in just minutes.',
    price: '$50',
    modal: {
      about: 'Professional haircut customized to enhance your features and fit your preferences.',
      process: ['Consultation', 'Wash', 'Cut and Style', 'Finishing Touches'],
      aftercare: ['Use quality hair products', 'Schedule regular trims'],
      recommendations: 'Refresh every 4-8 weeks',
    },
  },
  {
    id: 'tinting',
    title: 'Tinting',
    summary:
      'Looking for a quick lash enhancement? Our strip lashes offer a temporary yet stunning solution, giving you a full and defined lash line in just minutes.',
    price: '$50',
    modal: {
      about: 'Professional haircut customized to enhance your features and fit your preferences.',
      process: ['Consultation', 'Wash', 'Cut and Style', 'Finishing Touches'],
      aftercare: ['Use quality hair products', 'Schedule regular trims'],
      recommendations: 'Refresh every 4-8 weeks',
    },
  },
];